/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from 'react'

import UIButton from '../../components/UI/UIButton'

import UIStaightlineProressBar from '../../components/UI/UIStaightlineProressBar'

import { CircularProgressbar } from 'react-circular-progressbar'
import { Accordion, AccordionItem } from '../candidates/components/Accordion'
import { useQuery } from 'react-query'
import { getTraningCategoriesForSCR, User } from './apiCalls'
import { Icon } from '../../components/Icon'
import { lastStr } from '../policy/utils'
import {
  calculateNonNullPercentage,
  getTrainingScoreFields,
  aggregateTrainingScore,
} from '../../utils/utils'
import UIDocumentPicker from '../../components/UI/UIDocumentPicker'
import UiSelect from '../../components/UI/UISelect'
import UIDatePickerv from '../../components/UI/UIDatePickerv'
import UITextInput from '../../components/UI/UITextInput'
import {
  ErrorResponse,
  UploadResponse,
  UserTraningRecordsData,
  trainingRecords,
} from '../../utils/types'
import { fileUpload } from '../../api/apiService'
import { toast } from 'react-toastify'
import {
  AddUserTrainingRecords,
  updateUserTrainingRecords,
} from '../../api/lead/scr'
import {
  createRecordFormDataInterface,
  trainingRecordsData,
  updateRecordFormDataInterface,
} from '../myscr-records/TrainingRecord'
import PdfViewer from '../../components/UI/PdfViewer'
import { Comment, getColumnDataByCategoryId, TrainingRecor } from './utils'
import {
  rejectTrainingDocument,
  trainingRecordComment,
} from '../../api/admin/scr'
import { getAllUsers } from '../../api/admin/settings'

type AnyObject = { [key: string]: any }
type AnyArray = any[]
type TrainingRecord = {
  id?: string
  userId: string
  trainingRecordCategoryId: string
  schoolId: string
  certificateNumber: string | null
  date: string | null
  reviewDate: string | null
  verifiedBy: string | null
  verificationDate: string | null
  riskAssessmentStatus: string | null
  duration: string | null
  certificate: string | null
  riskDocument: string | null
}

function convertNullsToUndefined(
  obj: AnyObject | AnyArray,
  columnsToRemove?: string[]
): AnyObject | AnyArray | undefined {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertNullsToUndefined(item, columnsToRemove))
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc: AnyObject, key: string) => {
      if (!columnsToRemove?.includes(key)) {
        // Check if the key is not in the columns to remove
        acc[key] = convertNullsToUndefined(obj[key], columnsToRemove)
      }
      return acc
    }, {})
  } else {
    return obj === null ? undefined : obj
  }
}

const TrainingRecords = ({
  data,
  isEdit,
  setIsEdit,
  scrRecordRefetch,
}: {
  data?: User
  isEdit: boolean
  setIsEdit: Dispatch<SetStateAction<boolean>>
  scrRecordRefetch?: () => void
}) => {
  const { data: categories, refetch: refetchCategories } = useQuery(
    'categories',
    () => getTraningCategoriesForSCR()
  )

  const { data: AllUsers } = useQuery('users', () => getAllUsers())

  const [isOpenPdfViewer, setIsOpenPdfViewer] = useState<boolean>(false)
  const [pdfUrl, setPdfUrl] = useState('')
  const [showButtons, setShowButtons] = useState(false)
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)
  const [trainingRecords, setTrainingRecords] = useState<any>([])
  const [commentsInputs, setCommentInputs] = useState<{
    [key: string]: string
  }>({})
  const [trainingRecordId, setTrainingRecordId] = useState('')
  const [createRecordFormData, setCreateRecordFormData] = useState<
    createRecordFormDataInterface[]
  >([])
  const [updateRecordFormData, setUpdateRecordFormData] = useState<
    updateRecordFormDataInterface[]
  >([])

  const convertToUndefined = (value: any) => (value ? value : undefined)

  useEffect(() => {
    if (data?.trainingRecords !== undefined) {
      const mergedArray = categories?.data?.map((category) => {
        const matchingRecords =
          data?.trainingRecords?.filter(
            (record: any) => record.trainingRecordCategoryId === category.id
          ) || []
        // If no matching records are found, include only the category title
        if (matchingRecords.length === 0) {
          return {
            title: category.title,
            trainingRecordCategoryId: category.id,
          }
        } else {
          let obj = {}
          matchingRecords?.map((record: any) => {
            const updatedRecord: any = {}
            for (const key in record) {
              // eslint-disable-next-line no-prototype-builtins
              if (record?.hasOwnProperty(key)) {
                updatedRecord[key] = convertToUndefined(record[key])
              }
            }
            obj = {
              ...updatedRecord,
              title: category.title || undefined,
            }
          })
          return obj
        }
      })
      if (mergedArray) setTrainingRecords(mergedArray)
    }
  }, [data, categories])

  // riskAssessmentStatus

  const handleChange = (
    fieldName: string,
    value: string | boolean,
    item: trainingRecordsData,
    index?: number
  ) => {
    if (index !== undefined && fieldName === 'riskAssessmentStatus') {
      const updatedRecords = [...trainingRecords]
      updatedRecords[index] = {
        ...item,
        [fieldName]: value,
      }
      setTrainingRecords(updatedRecords)
    }
    if (Object.keys(item)?.length > 3) {
      setTrainingRecords((prev: any) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record: any) =>
            record.trainingRecordCategoryId === item.trainingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev?.map((record: any, index: number) => {
            if (index === existingItemIndex) {
              return {
                ...record,
                [fieldName]: value,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
      })
      setUpdateRecordFormData((prev) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record) =>
            record.trainingRecordCategoryId === item.trainingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev?.map((record, index) => {
            const { title, ...rest } = record
            if (index === existingItemIndex) {
              return {
                ...rest,
                [fieldName]: value,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
      })
    } else {
      if (fieldName == 'certificate' || undefined) {
        setTrainingRecords((prev: any) => {
          if (!prev) {
            // If previous state is undefined, return a new array with the updated item
            return [
              {
                ...item,
                [fieldName]: value,
              },
            ]
          }
          // Check if the item exists in the previous state
          const existingItemIndex = prev.findIndex(
            (record: any) =>
              record.trainingRecordCategoryId === item.trainingRecordCategoryId
          )
          if (existingItemIndex !== -1) {
            // If the item exists, update the specified field name with the provided value
            return prev?.map((record: any, index: number) => {
              if (index === existingItemIndex) {
                const { title, ...rest } = record
                return {
                  ...rest,
                  [fieldName]: value,
                }
              }
              return record
            })
          } else {
            // If the item doesn't exist, add it and update the specified field name with the provided value
            return [
              ...prev,
              {
                ...item,
                [fieldName]: value,
              },
            ]
          }
        })
      }
      setCreateRecordFormData((prev) => {
        const matchingRecords =
          prev?.filter(
            (record) =>
              record.trainingRecordCategoryId === item.trainingRecordCategoryId
          ) || []
        if (matchingRecords.length === 0) {
          const newItem = {
            ...item,
            [fieldName]: value,
          }
          return [...prev, newItem]
        } else {
          const updatedRecords =
            prev?.map((record) => {
              if (
                record.trainingRecordCategoryId ===
                item.trainingRecordCategoryId
              ) {
                const { title, ...rest } = record
                return {
                  ...rest,
                  [fieldName]: value,
                }
              }
              return record
            }) || []

          return updatedRecords
        }
      })
    }
  }

  const handleFileChange = async (
    category: string,
    event: ChangeEvent<HTMLInputElement>,
    item: trainingRecordsData
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('certificate', response?.url, item)
      } catch (error) {
        handleChange(
          'certificate',
          item?.certificate ? item?.certificate : '',
          item
        )
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
  }

  const handleRiskFileChange = async (
    category: string,
    event: ChangeEvent<HTMLInputElement>,
    item: trainingRecordsData
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('riskDocument', response?.url, item)
      } catch (error) {
        handleChange(
          'riskDocument',
          item?.riskDocument ? item?.riskDocument : '',
          item
        )
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
  }

  const updateTrainingRecodrdsData = async (): Promise<void> => {
    setIsUpdateLoading(true)
    try {
      if (createRecordFormData?.length != 0) {
        const convertedValues = convertNullsToUndefined(createRecordFormData, [
          'title',
        ])
        const bodyData = {
          // school: data?.schoolId || '',
          trainingRecords: convertedValues,
        } as UserTraningRecordsData
        const response = (await AddUserTrainingRecords(
          bodyData,
          data?.schoolId || '',
          data?.userId
        )) as {
          status?: string
          data: any
        }
        if (response?.status == 'successful') {
          refetchCategories()
          scrRecordRefetch && scrRecordRefetch()
          setIsEdit(false)
          setCreateRecordFormData([])
          toast.success('Records Updated.', {
            position: 'top-right',
          })
        } else {
          toast.error('Network Error.', {
            position: 'top-right',
          })
        }
      }
    } catch (error) {
      toast.error('An error occurred while updating records.', {
        position: 'top-right',
      })
    } finally {
      setIsUpdateLoading(false)
    }
    try {
      setIsUpdateLoading(true)
      if (updateRecordFormData?.length != 0) {
        const convertedValues = convertNullsToUndefined(updateRecordFormData, [
          'title',
        ])
        // =====> remove riskDocumentUrl, certificateUrl field api can't accept these fields
        const updatedRecords = convertedValues?.map((record: any) => {
          // Handle potential undefined documentUrl property
          const {
            riskDocumentUrl,
            certificateUrl,
            trainingId,
            comments,
            firstName,
            ...rest
          } = record || {}
          return { ...rest, id: trainingId }
        })
        // =====> remove riskDocumentUrl, certificateUrl field api can't accept these fields
        const bodyData = {
          trainingRecords: updatedRecords,
        } as UserTraningRecordsData
        const response = (await updateUserTrainingRecords(
          bodyData,
          data?.schoolId || '',
          data?.userId
        )) as {
          status?: string
          data: trainingRecords
        }
        if (response?.status == 'successful') {
          setUpdateRecordFormData([])
          refetchCategories()
          scrRecordRefetch && scrRecordRefetch()
          setIsEdit(false)
          toast.success('Records Updated.', {
            position: 'top-right',
          })
        } else {
          toast.error('Network Error.', {
            position: 'top-right',
          })
        }
      }
    } catch (error) {
      toast.error('An error occurred while updating records.', {
        position: 'top-right',
      })
    } finally {
      setIsUpdateLoading(false)
    }
  }

  const verifyDoc = async (status: string): Promise<void> => {
    try {
      const response = (await rejectTrainingDocument(
        trainingRecordId,
        status
      )) as {
        status?: string
        data: trainingRecords
      }
      if (response?.status == 'successful') {
        setUpdateRecordFormData([])
        refetchCategories()
        scrRecordRefetch && scrRecordRefetch()
        setIsEdit(false)
        setShowButtons(false)
        toast.success(
          `Document ${status.toLowerCase().replace(/\b./g, function (a) {
            return a.toUpperCase()
          })}.`,
          {
            position: 'top-right',
          }
        )
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    } finally {
      setIsUpdateLoading(false)
    }
  }

  const postComment = async (
    trainingId: string,
    comment: string
  ): Promise<void> => {
    try {
      const response = (await trainingRecordComment(
        data?.userId as string,
        trainingId,
        data?.schoolId as string,
        comment
      )) as {
        status?: string
      }
      if (response?.status == 'successful') {
        setUpdateRecordFormData([])
        refetchCategories()
        scrRecordRefetch && scrRecordRefetch()
        setIsEdit(false)
        toast.success(`Comment Sent.`, {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  function countNonNullFields(
    records: TrainingRecord[],
    fields: (keyof TrainingRecord)[]
  ): number {
    let nonNullCount = 0

    for (const record of records) {
      for (const field of fields) {
        if (record[field] !== null) {
          nonNullCount++
        }
      }
    }

    return nonNullCount
  }
  const fieldsToCheck: (keyof TrainingRecord)[] = [
    'certificateNumber',
    'date',
    'reviewDate',
    'verifiedBy',
    'verificationDate',
    'riskAssessmentStatus',
    'duration',
    'certificate',
    'riskDocument',
  ]

  // Overall scorecard, shared with the candidate view via utils so the same
  // record scores identically here and on My SCR (Behaviour B).
  const scorecard = aggregateTrainingScore(categories?.data, trainingRecords)

  return (
    <div
      style={{
        height: 'calc(100vh - 100px)',
        overflow: 'auto',
        // scrollbarWidth: 'none',
        scrollbarWidth: 'none',
      }}
    >
      <div className="flex my-8 gap-2">
        {/* First column */}
        <div
          style={{
            // height: 'calc(100vh - 100px)',
            overflow: 'auto',
            scrollbarWidth: 'none',
          }}
          className="flex flex-col w-8/12 gap-4"
        >
          {isEdit ? (
            <>
              {trainingRecords?.map((item: any, index: number) => {
                return (
                  <Accordion key={index} defaultActiveIndex={null}>
                    <AccordionItem
                      title={item?.title ? item?.title : ''}
                      isActive={false}
                    >
                      <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UITextInput
                              placeholder={'Certificate Number'}
                              label={'Certificate Number'}
                              iconName={''}
                              type={'text'}
                              value={item ? item?.certificateNumber : ''}
                              onChange={(e) =>
                                handleChange(
                                  'certificateNumber',
                                  e.target.value,
                                  item
                                )
                              }
                            />
                          </div>
                        </div>
                        <UIDocumentPicker
                          id={item?.title ? item?.title : 'pickerInput'}
                          handleRemoveFile={() => {
                            handleChange('certificate', '', item)
                          }}
                          label={'Certificate'}
                          initialValue={
                            item?.certificate ? item?.certificate : ''
                          }
                          onChange={(e) =>
                            handleFileChange('certificate', e, item)
                          }
                          accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                          labelClassName="custom-label-class"
                        />
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UIDatePickerv
                              placeholderText={'Not Specified'}
                              title={'Date'}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleChange('date', e.target.value, item)
                              }}
                              value={item?.date ? item?.date.split('T')[0] : ''}
                            />
                          </div>
                          <div className="w-6/12">
                            <UIDatePickerv
                              placeholderText={'Not Specified'}
                              title={'Review Date'}
                              value={
                                item?.reviewDate
                                  ? item?.reviewDate.split('T')[0]
                                  : ''
                              }
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleChange('reviewDate', e.target.value, item)
                              }}
                            />
                          </div>
                        </div>
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UiSelect
                              options={
                                (
                                  AllUsers as {
                                    data: {
                                      data: {
                                        userId: string
                                        firstName: string
                                      }[]
                                    }
                                  }
                                )?.data?.data?.map((i) => ({
                                  value: i.userId,
                                  label: i.firstName,
                                })) || []
                              }
                              title={'Verified by'}
                              value={item?.verifiedBy ? item?.verifiedBy : ''}
                              onChange={(e) =>
                                handleChange('verifiedBy', e, item)
                              }
                            />
                          </div>
                          <div className="w-6/12">
                            <UIDatePickerv
                              placeholderText={'Not Specified'}
                              title={'Verification Date'}
                              value={
                                item?.verificationDate
                                  ? item?.verificationDate.split('T')[0]
                                  : ''
                              }
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleChange(
                                  'verificationDate',
                                  e.target.value,
                                  item
                                )
                              }}
                            />
                          </div>
                        </div>
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UiSelect
                              options={[
                                { value: 'YES', label: 'YES' },
                                { value: 'NO', label: 'NO' },
                              ]}
                              title={'Risk Assessment Status'}
                              value={
                                item?.riskAssessmentStatus
                                  ? item?.riskAssessmentStatus
                                  : ''
                              }
                              onChange={(e: string) => {
                                handleChange(
                                  'riskAssessmentStatus',
                                  e,
                                  item,
                                  index
                                )
                              }}
                            />
                          </div>
                          {item.riskAssessmentStatus !== 'NO' && (
                            <div className="w-6/12">
                              <UiSelect
                                options={[
                                  { value: '12 Months', label: '12 Months' },
                                  { value: '9 Months', label: '9 Months' },
                                  { value: '6 Months', label: '6 Months' },
                                  { value: '3 Months', label: '3 Months' },
                                  { value: '0 Months', label: '0 Months' },
                                ]}
                                title={'Duration'}
                                value={item?.duration}
                                onChange={(e: string) => {
                                  handleChange('duration', e, item)
                                }}
                              />
                            </div>
                          )}
                        </div>
                        {item.riskAssessmentStatus !== 'NO' && (
                          <UIDocumentPicker
                            id={item?.title ? item?.title : 'pickerInput'}
                            handleRemoveFile={() => {
                              handleChange('riskDocument', '', item)
                            }}
                            label={'Risk Assessment Document'}
                            initialValue={
                              item?.riskDocument ? item?.riskDocument : ''
                            }
                            onChange={(e) =>
                              handleRiskFileChange('riskDocument', e, item)
                            }
                            accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                            labelClassName="custom-label-class"
                          />
                        )}
                      </div>
                    </AccordionItem>
                  </Accordion>
                )
              })}
              <div className="w-[33%] mt-6">
                <UIButton
                  onClick={updateTrainingRecodrdsData}
                  loading={isUpdateLoading}
                  label="Update"
                />
              </div>
            </>
          ) : (
            <>
              {categories?.data?.map((item, index) => (
                <Accordion key={item.id} defaultActiveIndex={0}>
                  <AccordionItem title={item?.title} isActive={false}>
                    <div className="flex flex-col mt-2 my-4 px-2">
                      <div className="overflow-hidden rounded-[16px] w-full mb-[30px]">
                        <table className="rounded-[16px] overflow-hidden border w-full border-white">
                          <tbody>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Certificate Number
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {getColumnDataByCategoryId(
                                  data!.trainingRecords as TrainingRecor[],
                                  item.id,
                                  'certificateNumber'
                                )}
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                External url
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {item?.referenceUrl}
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Date
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {
                                  (
                                    (getColumnDataByCategoryId(
                                      data!.trainingRecords as TrainingRecor[],
                                      item.id,
                                      'date'
                                    )[0] || '') as string
                                  ).split('T')[0]
                                }
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Review Date
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {
                                  (
                                    (getColumnDataByCategoryId(
                                      data!.trainingRecords as TrainingRecor[],
                                      item.id,
                                      'reviewDate'
                                    )[0] || '') as string
                                  ).split('T')[0]
                                }
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Verified By
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {getColumnDataByCategoryId(
                                  data!.trainingRecords as TrainingRecor[],
                                  item.id,
                                  'firstName'
                                )}
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Verification Date
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {
                                  (
                                    (getColumnDataByCategoryId(
                                      data!.trainingRecords as TrainingRecor[],
                                      item.id,
                                      'verificationDate'
                                    )[0] || '') as string
                                  ).split('T')[0]
                                }
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Risk Assessment Status
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {getColumnDataByCategoryId(
                                  data!.trainingRecords as TrainingRecor[],
                                  item.id,
                                  'riskAssessmentStatus'
                                )}
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Duration
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {getColumnDataByCategoryId(
                                  data!.trainingRecords as TrainingRecor[],
                                  item.id,
                                  'duration'
                                )}
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Certificate
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                <div
                                  onClick={() => {
                                    const url =
                                      getColumnDataByCategoryId(
                                        data!
                                          .trainingRecords as TrainingRecor[],
                                        item.id,
                                        'certificateUrl'
                                      ) || null

                                    if (!url[0]) return

                                    if (
                                      (url as unknown as string) ==
                                      'IN PROGRESS'
                                    ) {
                                      return toast.warning(
                                        'Scanning the file, please check again in a few seconds.',
                                        {
                                          position: 'top-right',
                                        }
                                      )
                                    }
                                    if (
                                      (url as unknown as string) == 'NoSuchKey'
                                    ) {
                                      return toast.warning('File is removed', {
                                        position: 'top-right',
                                      })
                                    }

                                    setTrainingRecordId(
                                      getColumnDataByCategoryId(
                                        data!
                                          .trainingRecords as TrainingRecor[],
                                        item.id,
                                        'trainingId'
                                      ).toString()
                                    )
                                    setPdfUrl(`${url}`)
                                    if (
                                      getColumnDataByCategoryId(
                                        data!
                                          .trainingRecords as TrainingRecor[],
                                        item.id,
                                        'document_verification_status'
                                      )[0] == 'pending'
                                    ) {
                                      setShowButtons(true)
                                    } else {
                                      setShowButtons(false)
                                    }
                                    setIsOpenPdfViewer(true)
                                  }}
                                  key={index}
                                  className="p-4 w-[268px] h-[48px] flex gap-2 items-center bg-white rounded-lg"
                                >
                                  <Icon
                                    name="IconFile"
                                    width={16}
                                    height={16}
                                    strokeWidth={2}
                                    stroke={'#02698C'}
                                  />
                                  <p className="text-sm font-semibold text-bluishGreen leading-6 flex-1">
                                    {getColumnDataByCategoryId(
                                      data!.trainingRecords as TrainingRecor[],
                                      item.id,
                                      'certificate'
                                    )[0] == null
                                      ? 'No File'
                                      : lastStr(
                                          getColumnDataByCategoryId(
                                            data!
                                              .trainingRecords as TrainingRecor[],
                                            item.id,
                                            'certificate'
                                          )[0] as string
                                        )}
                                    {/* <span className="text-xs font-medium leading-5 text-text3">
                                      1.7 MB
                                    </span> */}
                                  </p>
                                  <Icon
                                    name="IconDownloadCloud"
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#67A5B9'}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Risk Assessment Document
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                <div
                                  onClick={() => {
                                    const url =
                                      getColumnDataByCategoryId(
                                        data!
                                          .trainingRecords as TrainingRecor[],
                                        item.id,
                                        'riskDocumentUrl'
                                      ) || null

                                    if (!url[0]) return

                                    if (
                                      (url as unknown as string) ==
                                      'IN PROGRESS'
                                    ) {
                                      return toast.warning(
                                        'Scanning the file, please check again in a few seconds.',
                                        {
                                          position: 'top-right',
                                        }
                                      )
                                    }
                                    if (
                                      (url as unknown as string) == 'NoSuchKey'
                                    ) {
                                      return toast.warning('File is removed', {
                                        position: 'top-right',
                                      })
                                    }

                                    setTrainingRecordId(
                                      getColumnDataByCategoryId(
                                        data!
                                          .trainingRecords as TrainingRecor[],
                                        item.id,
                                        'trainingId'
                                      ).toString()
                                    )

                                    setPdfUrl(`${url}`)
                                    setIsOpenPdfViewer(true)
                                  }}
                                  key={index}
                                  className="p-4 w-[268px] h-[48px] flex gap-2 items-center bg-white rounded-lg"
                                >
                                  <Icon
                                    name="IconFile"
                                    width={16}
                                    height={16}
                                    strokeWidth={2}
                                    stroke={'#02698C'}
                                  />
                                  <p className="text-sm font-semibold text-bluishGreen leading-6 flex-1">
                                    {getColumnDataByCategoryId(
                                      data!.trainingRecords as TrainingRecor[],
                                      item.id,
                                      'riskDocument'
                                    )[0] == null
                                      ? 'No File'
                                      : lastStr(
                                          getColumnDataByCategoryId(
                                            data!
                                              .trainingRecords as TrainingRecor[],
                                            item.id,
                                            'riskDocument'
                                          )[0] as string
                                        )}
                                    {/* <span className="text-xs font-medium leading-5 text-text3">
                                      1.7 MB
                                    </span> */}
                                  </p>
                                  <Icon
                                    name="IconDownloadCloud"
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#67A5B9'}
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        {(() => {
                          const id = getColumnDataByCategoryId(
                            data!.trainingRecords as TrainingRecor[],
                            item.id,
                            'trainingId'
                          )[0] as string

                          if (!id) {
                            return <></>
                          }

                          return (
                            <>
                              <table className="mt-5 rounded-[16px] overflow-hidden border w-full border-white">
                                <tbody>
                                  <tr>
                                    <td>Comment:</td>
                                    <td className="px-4 text-text1 font-semibold w-[100%] text-[14px] h-[48px] py-2 border border-white">
                                      <UITextInput
                                        placeholder={'Write here...'}
                                        iconName=""
                                        value={(() => {
                                          const id = getColumnDataByCategoryId(
                                            data!
                                              .trainingRecords as TrainingRecor[],
                                            item.id,
                                            'trainingId'
                                          )[0] as string
                                          return commentsInputs[id] || ''
                                        })()}
                                        onChange={(e) => {
                                          const id = getColumnDataByCategoryId(
                                            data!
                                              .trainingRecords as TrainingRecor[],
                                            item.id,
                                            'trainingId'
                                          )[0] as string
                                          setCommentInputs((pri) => ({
                                            ...pri,
                                            [id]: e.target.value,
                                          }))
                                        }}
                                      />
                                    </td>
                                    <td className="w-[11px] self-baseline">
                                      <UIButton
                                        onClick={() => {
                                          const id = getColumnDataByCategoryId(
                                            data!
                                              .trainingRecords as TrainingRecor[],
                                            item.id,
                                            'trainingId'
                                          )[0] as string
                                          if (commentsInputs[id]) {
                                            postComment(id, commentsInputs[id])
                                            setCommentInputs((pri) => ({
                                              ...pri,
                                              [id]: '',
                                            }))
                                          }
                                        }}
                                        loading={false}
                                        secondary
                                        label="Commit"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              {/*// @ts-expect-error saas */}
                              {data?.trainingRecords.find(
                                (record) =>
                                  record.trainingRecordCategoryId === item.id
                              )?.comments.length > 0 && (
                                <h3 className="mt-2 p-1">Comments:</h3>
                              )}
                              <table className="rounded-[16px] overflow-hidden border w-full border-white">
                                <tbody>
                                  {// @ts-expect-error temp
                                  data.trainingRecords
                                    .find(
                                      (record) =>
                                        record.trainingRecordCategoryId ===
                                        item.id
                                    )
                                    ?.comments.slice()
                                    .reverse()
                                    .map((comment: Comment) => {
                                      return (
                                        <tr
                                          className="bg-gray1"
                                          key={comment.commentId}
                                        >
                                          {/* Example row */}
                                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                            Created By : {comment.firstName}
                                          </td>
                                          <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                            {comment.comment}
                                          </td>
                                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                            Created At:{' '}
                                            {
                                              (
                                                comment['comments.createdAt'] ||
                                                ''
                                              ).split('T')[0]
                                            }
                                          </td>
                                        </tr>
                                      )
                                    })}
                                </tbody>
                              </table>
                            </>
                          )
                        })()}
                      </div>
                    </div>
                  </AccordionItem>
                </Accordion>
              ))}
            </>
          )}
        </div>

        {/* Second column */}
        <div className="w-4/12">
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              title={'Scorecard'}
              isActive={true}
              AccordionItemStyle={{
                backgroundColor: 'rgba(230, 240, 243, 1)',
              }}
              AccordiontitleStyle={
                'text-sm font-semibold text-bluishGreen leading-6'
              }
              AccordionItemStyleContainer={{
                backgroundColor: 'rgba(242, 247, 249, 1)',
              }}
              icon={'IconBarChartSquare'}
            >
              <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                <div className="w-[160px] h-[160px]">
                  <CircularProgressbar
                    strokeWidth={5}
                    value={scorecard.percentage}
                    text={`${scorecard.percentage}%`}
                    styles={{
                      root: {},
                      path: {
                        stroke: scorecard.color,
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                      },
                      text: {
                        fill: '#013546',
                        fontSize: '24px',
                        fontWeight: 700,
                        lineHeight: 40,
                      },
                    }}
                  />
                </div>
                <div className="w-full bg-white flex flex-col gap-4 my-4 px-4 py-4 rounded-xl">
                  {categories?.data?.map((item, index) => {
                    const fieldsToCheck = getTrainingScoreFields(
                      trainingRecords?.[index]
                    )

                    return (
                      <div key={index} className="">
                        <div className="">
                          <UIStaightlineProressBar
                            percentage={
                              calculateNonNullPercentage(fieldsToCheck)
                                .percentage
                            }
                            label={item?.title}
                            stroke={
                              calculateNonNullPercentage(fieldsToCheck).color
                            }
                            strokeWidth={1.5}
                          />
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <PdfViewer
        isOpen={isOpenPdfViewer}
        onClose={() => {
          setIsOpenPdfViewer(false)
        }}
        showButtons={showButtons}
        onAccept={() => verifyDoc('accepted')}
        onReject={() => verifyDoc('rejected')}
        url={pdfUrl}
        title="PDF Viewer"
      />
    </div>
  )
}

export default TrainingRecords
